import { render, staticRenderFns } from "./ShareGroupbuying.vue?vue&type=template&id=51dcb8ae&"
import script from "./ShareGroupbuying.vue?vue&type=script&lang=js&"
export * from "./ShareGroupbuying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports